module.exports = __webpack_public_path__ + "media/views/about/images/icons/faq_8-4d28bd4032f1b15060d2328b07eeb4b4.svg";